import * as types from '../actions/familyAccess/types';


const INITIAL_STATE = {
  accounts: [],
  active: {},
  primary: {},
  users: [],
};

export default function familyAccessReducer(state = INITIAL_STATE, action) {

  switch(action.type) {
    case types.GET_ACCOUNTS:

      return {
        ...state,
        accounts: action.payload.accounts,
        active: action.payload.active,
        primary: action.payload.primary,
      };

    case types.GET_ACCESS_USERS:

      return { ...state, users: action.payload };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/familyAccessReducer.js